import React from 'react'

const EmployeePayroll = () => {
  return (
    <div>EmployeePayroll</div>
  )
}

export default EmployeePayroll